import { MARQUEE } from "@/lib/content";

export function Marquee({ items = MARQUEE, dark = false }) {
  const list = [...items, ...items];
  return (
    <div className={`marquee overflow-hidden border-y ${dark ? "border-paper/10 text-paper/70" : "border-line text-ink"} py-5`} aria-hidden>
      <div className="marquee-track">
        {list.map((t, i) => (
          <span key={i} className="flex items-center gap-10 pr-10">
            <span className="display text-2xl md:text-3xl uppercase tracking-[-0.02em] whitespace-nowrap">{t}</span>
            <span className={`w-1.5 h-1.5 rounded-full ${i % 6 === 2 ? "bg-signal" : dark ? "bg-paper/40" : "bg-ink/30"}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
